 import axios from 'axios';
import { StorageKey } from '../types';
const setTokenHeader = async () => {
	const token = await JSON.parse(localStorage.getItem(StorageKey.UserToken)|| '{}');
	if (token) {
	
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
	}else{
		console.log('No token')
	}
};

export default setTokenHeader;

 